/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ModelNames,
  ErrorInfo,
  Doors,
  Engines,
  Destinations,
  Factories,
  DevelopmentBases,
  ProductionDivisions,
  DevelopmentScales,
  Languages,
  Companies,
  ProductionProcesses,
  ProductionStatuses,
  GetProductionStatusesParams,
  ScheduleDivisions,
  Holidays,
  GetHolidaysParams,
  CompanyTrees,
  GetGroupSearchParams,
  MasterSettings,
  GetMastersSettingsParams,
  ChapterNumbers,
  JudgmentDivisions,
  MastersSearch,
  MastersSearchConditions,
  BinaryFile,
  MasterDetail,
  PostMasterMupload200,
  PostMasterMuploadBody
} from '.././model'


/**
 * 制作管理テーブルから機種名一覧を取得して返す。(名前順)

 * @summary 機種名一覧取得
 */
export const getModelNames = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ModelNames>> => {
    return axios.get(
      `/masters/modelNames`,options
    );
  }


export const getGetModelNamesQueryKey = () => [`/masters/modelNames`];

    
export type GetModelNamesQueryResult = NonNullable<Awaited<ReturnType<typeof getModelNames>>>
export type GetModelNamesQueryError = AxiosError<ErrorInfo>

export const useGetModelNames = <TData = Awaited<ReturnType<typeof getModelNames>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getModelNames>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModelNamesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelNames>>> = ({ signal }) => getModelNames({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getModelNames>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * ドアテーブルからドア一覧を取得して返す。(sort_order順)

 * @summary ドア一覧取得
 */
export const getDoors = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Doors>> => {
    return axios.get(
      `/masters/doors`,options
    );
  }


export const getGetDoorsQueryKey = () => [`/masters/doors`];

    
export type GetDoorsQueryResult = NonNullable<Awaited<ReturnType<typeof getDoors>>>
export type GetDoorsQueryError = AxiosError<ErrorInfo>

export const useGetDoors = <TData = Awaited<ReturnType<typeof getDoors>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDoors>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDoorsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDoors>>> = ({ signal }) => getDoors({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getDoors>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * エンジンテーブルからエンジン一覧を取得して返す。(sort_order順)

 * @summary エンジン一覧取得
 */
export const getEngines = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Engines>> => {
    return axios.get(
      `/masters/engines`,options
    );
  }


export const getGetEnginesQueryKey = () => [`/masters/engines`];

    
export type GetEnginesQueryResult = NonNullable<Awaited<ReturnType<typeof getEngines>>>
export type GetEnginesQueryError = AxiosError<ErrorInfo>

export const useGetEngines = <TData = Awaited<ReturnType<typeof getEngines>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEngines>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEnginesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEngines>>> = ({ signal }) => getEngines({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getEngines>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 仕向テーブルから仕向一覧を取得して返す。(sort_order順)

 * @summary 仕向一覧取得
 */
export const getDestinations = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Destinations>> => {
    return axios.get(
      `/masters/destinations`,options
    );
  }


export const getGetDestinationsQueryKey = () => [`/masters/destinations`];

    
export type GetDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof getDestinations>>>
export type GetDestinationsQueryError = AxiosError<ErrorInfo>

export const useGetDestinations = <TData = Awaited<ReturnType<typeof getDestinations>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDestinations>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDestinationsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDestinations>>> = ({ signal }) => getDestinations({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getDestinations>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 工場テーブルから工場一覧を取得して返す。(sort_order順)

 * @summary 工場一覧取得
 */
export const getFactories = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Factories>> => {
    return axios.get(
      `/masters/factories`,options
    );
  }


export const getGetFactoriesQueryKey = () => [`/masters/factories`];

    
export type GetFactoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getFactories>>>
export type GetFactoriesQueryError = AxiosError<ErrorInfo>

export const useGetFactories = <TData = Awaited<ReturnType<typeof getFactories>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFactories>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFactoriesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFactories>>> = ({ signal }) => getFactories({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getFactories>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 開発拠点テーブルから開発拠点一覧を取得して返す。(sort_order順)

 * @summary 開発拠点一覧取得
 */
export const getDevelopmentBases = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DevelopmentBases>> => {
    return axios.get(
      `/masters/developmentBases`,options
    );
  }


export const getGetDevelopmentBasesQueryKey = () => [`/masters/developmentBases`];

    
export type GetDevelopmentBasesQueryResult = NonNullable<Awaited<ReturnType<typeof getDevelopmentBases>>>
export type GetDevelopmentBasesQueryError = AxiosError<ErrorInfo>

export const useGetDevelopmentBases = <TData = Awaited<ReturnType<typeof getDevelopmentBases>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDevelopmentBases>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDevelopmentBasesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevelopmentBases>>> = ({ signal }) => getDevelopmentBases({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getDevelopmentBases>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 資料区分テーブルから資料区分一覧を取得して返す。(sort_order順)

 * @summary 資料区分一覧取得
 */
export const getProductionDivisions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProductionDivisions>> => {
    return axios.get(
      `/masters/productionDivisions`,options
    );
  }


export const getGetProductionDivisionsQueryKey = () => [`/masters/productionDivisions`];

    
export type GetProductionDivisionsQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionDivisions>>>
export type GetProductionDivisionsQueryError = AxiosError<ErrorInfo>

export const useGetProductionDivisions = <TData = Awaited<ReturnType<typeof getProductionDivisions>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductionDivisions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductionDivisionsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionDivisions>>> = ({ signal }) => getProductionDivisions({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getProductionDivisions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 開発規模テーブルから開発規模一覧を取得して返す。(sort_order順)

 * @summary 開発規模一覧取得
 */
export const getDevelopmentScales = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DevelopmentScales>> => {
    return axios.get(
      `/masters/developmentScales`,options
    );
  }


export const getGetDevelopmentScalesQueryKey = () => [`/masters/developmentScales`];

    
export type GetDevelopmentScalesQueryResult = NonNullable<Awaited<ReturnType<typeof getDevelopmentScales>>>
export type GetDevelopmentScalesQueryError = AxiosError<ErrorInfo>

export const useGetDevelopmentScales = <TData = Awaited<ReturnType<typeof getDevelopmentScales>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDevelopmentScales>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDevelopmentScalesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevelopmentScales>>> = ({ signal }) => getDevelopmentScales({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getDevelopmentScales>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 言語テーブルから言語一覧を取得して返す。(sort_order順)

 * @summary 言語一覧取得
 */
export const getLanguages = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Languages>> => {
    return axios.get(
      `/masters/languages`,options
    );
  }


export const getGetLanguagesQueryKey = () => [`/masters/languages`];

    
export type GetLanguagesQueryResult = NonNullable<Awaited<ReturnType<typeof getLanguages>>>
export type GetLanguagesQueryError = AxiosError<ErrorInfo>

export const useGetLanguages = <TData = Awaited<ReturnType<typeof getLanguages>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLanguagesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLanguages>>> = ({ signal }) => getLanguages({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getLanguages>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 会社テーブルから会社一覧を取得して返す。(sort_order順)

 * @summary 会社一覧取得
 */
export const getCompanies = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Companies>> => {
    return axios.get(
      `/masters/companies`,options
    );
  }


export const getGetCompaniesQueryKey = () => [`/masters/companies`];

    
export type GetCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanies>>>
export type GetCompaniesQueryError = AxiosError<ErrorInfo>

export const useGetCompanies = <TData = Awaited<ReturnType<typeof getCompanies>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompaniesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanies>>> = ({ signal }) => getCompanies({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getCompanies>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 制作工程テーブルから制作工程一覧を取得して返す。(sort_order順)

 * @summary 制作工程一覧取得
 */
export const getProductionProcesses = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProductionProcesses>> => {
    return axios.get(
      `/masters/productionProcesses`,options
    );
  }


export const getGetProductionProcessesQueryKey = () => [`/masters/productionProcesses`];

    
export type GetProductionProcessesQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionProcesses>>>
export type GetProductionProcessesQueryError = AxiosError<ErrorInfo>

export const useGetProductionProcesses = <TData = Awaited<ReturnType<typeof getProductionProcesses>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductionProcesses>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductionProcessesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionProcesses>>> = ({ signal }) => getProductionProcesses({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getProductionProcesses>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 制作ステータステーブルから制作ステータス一覧を取得して返す。(sort_order順)

 * @summary 制作ステータス一覧取得
 */
export const getProductionStatuses = (
    params: GetProductionStatusesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProductionStatuses>> => {
    return axios.get(
      `/masters/productionStatuses`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetProductionStatusesQueryKey = (params: GetProductionStatusesParams,) => [`/masters/productionStatuses`, ...(params ? [params]: [])];

    
export type GetProductionStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionStatuses>>>
export type GetProductionStatusesQueryError = AxiosError<ErrorInfo>

export const useGetProductionStatuses = <TData = Awaited<ReturnType<typeof getProductionStatuses>>, TError = AxiosError<ErrorInfo>>(
 params: GetProductionStatusesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductionStatuses>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductionStatusesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionStatuses>>> = ({ signal }) => getProductionStatuses(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getProductionStatuses>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 日程区分テーブルから日程区分一覧を取得して返す。(sort_order順)

 * @summary 日程区分一覧取得
 */
export const getScheduleDivisions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ScheduleDivisions>> => {
    return axios.get(
      `/masters/scheduleDivisions`,options
    );
  }


export const getGetScheduleDivisionsQueryKey = () => [`/masters/scheduleDivisions`];

    
export type GetScheduleDivisionsQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleDivisions>>>
export type GetScheduleDivisionsQueryError = AxiosError<ErrorInfo>

export const useGetScheduleDivisions = <TData = Awaited<ReturnType<typeof getScheduleDivisions>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScheduleDivisions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScheduleDivisionsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleDivisions>>> = ({ signal }) => getScheduleDivisions({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getScheduleDivisions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 休日テーブルから休日一覧を取得して返す。(開始日付順)

 * @summary 休日一覧取得
 */
export const getHolidays = (
    params?: GetHolidaysParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Holidays>> => {
    return axios.get(
      `/masters/holidays`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetHolidaysQueryKey = (params?: GetHolidaysParams,) => [`/masters/holidays`, ...(params ? [params]: [])];

    
export type GetHolidaysQueryResult = NonNullable<Awaited<ReturnType<typeof getHolidays>>>
export type GetHolidaysQueryError = AxiosError<ErrorInfo>

export const useGetHolidays = <TData = Awaited<ReturnType<typeof getHolidays>>, TError = AxiosError<ErrorInfo>>(
 params?: GetHolidaysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHolidays>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHolidaysQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHolidays>>> = ({ signal }) => getHolidays(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getHolidays>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 機種担当選択一覧取得

 * @summary 機種担当選択一覧取得
 */
export const getModelUsers = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CompanyTrees>> => {
    return axios.get(
      `/masters/modelUsers`,options
    );
  }


export const getGetModelUsersQueryKey = () => [`/masters/modelUsers`];

    
export type GetModelUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getModelUsers>>>
export type GetModelUsersQueryError = AxiosError<ErrorInfo>

export const useGetModelUsers = <TData = Awaited<ReturnType<typeof getModelUsers>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getModelUsers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModelUsersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelUsers>>> = ({ signal }) => getModelUsers({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getModelUsers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 原作推進担当選択一覧取得

 * @summary 原作推進担当選択一覧取得
 */
export const getOriginalWorkUsers = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CompanyTrees>> => {
    return axios.get(
      `/masters/originalWorkUsers`,options
    );
  }


export const getGetOriginalWorkUsersQueryKey = () => [`/masters/originalWorkUsers`];

    
export type GetOriginalWorkUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getOriginalWorkUsers>>>
export type GetOriginalWorkUsersQueryError = AxiosError<ErrorInfo>

export const useGetOriginalWorkUsers = <TData = Awaited<ReturnType<typeof getOriginalWorkUsers>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOriginalWorkUsers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOriginalWorkUsersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOriginalWorkUsers>>> = ({ signal }) => getOriginalWorkUsers({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getOriginalWorkUsers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 日程共有先選択一覧取得

 * @summary 日程共有先選択一覧取得
 */
export const getScheduleSharingList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CompanyTrees>> => {
    return axios.get(
      `/masters/scheduleSharingList`,options
    );
  }


export const getGetScheduleSharingListQueryKey = () => [`/masters/scheduleSharingList`];

    
export type GetScheduleSharingListQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleSharingList>>>
export type GetScheduleSharingListQueryError = AxiosError<ErrorInfo>

export const useGetScheduleSharingList = <TData = Awaited<ReturnType<typeof getScheduleSharingList>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScheduleSharingList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScheduleSharingListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleSharingList>>> = ({ signal }) => getScheduleSharingList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getScheduleSharingList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * グループツリーを表示します。

 * @summary グループツリーを表示
 */
export const getGroupSearch = (
    params?: GetGroupSearchParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CompanyTrees>> => {
    return axios.get(
      `/masters/groupsearch`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetGroupSearchQueryKey = (params?: GetGroupSearchParams,) => [`/masters/groupsearch`, ...(params ? [params]: [])];

    
export type GetGroupSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupSearch>>>
export type GetGroupSearchQueryError = AxiosError<ErrorInfo>

export const useGetGroupSearch = <TData = Awaited<ReturnType<typeof getGroupSearch>>, TError = AxiosError<ErrorInfo>>(
 params?: GetGroupSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGroupSearch>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGroupSearchQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupSearch>>> = ({ signal }) => getGroupSearch(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getGroupSearch>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * マスタセッティングの一覧を取得（マスタID毎）

 * @summary マスタセッティングの一覧を取得（マスタID毎）
 */
export const getMastersSettings = (
    params?: GetMastersSettingsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MasterSettings>> => {
    return axios.get(
      `/masters/settings`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetMastersSettingsQueryKey = (params?: GetMastersSettingsParams,) => [`/masters/settings`, ...(params ? [params]: [])];

    
export type GetMastersSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getMastersSettings>>>
export type GetMastersSettingsQueryError = AxiosError<ErrorInfo>

export const useGetMastersSettings = <TData = Awaited<ReturnType<typeof getMastersSettings>>, TError = AxiosError<ErrorInfo>>(
 params?: GetMastersSettingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMastersSettings>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMastersSettingsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMastersSettings>>> = ({ signal }) => getMastersSettings(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getMastersSettings>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 章番号一覧

 * @summary 章番号一覧
 */
export const getChapterNumbers = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChapterNumbers>> => {
    return axios.get(
      `/masters/chapterNumbers`,options
    );
  }


export const getGetChapterNumbersQueryKey = () => [`/masters/chapterNumbers`];

    
export type GetChapterNumbersQueryResult = NonNullable<Awaited<ReturnType<typeof getChapterNumbers>>>
export type GetChapterNumbersQueryError = AxiosError<ErrorInfo>

export const useGetChapterNumbers = <TData = Awaited<ReturnType<typeof getChapterNumbers>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getChapterNumbers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChapterNumbersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChapterNumbers>>> = ({ signal }) => getChapterNumbers({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getChapterNumbers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * ベース原稿判定一覧

 * @summary ベース原稿判定一覧
 */
export const getJudgmentDivisions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<JudgmentDivisions>> => {
    return axios.get(
      `/masters/JudgmentDivisions`,options
    );
  }


export const getGetJudgmentDivisionsQueryKey = () => [`/masters/JudgmentDivisions`];

    
export type GetJudgmentDivisionsQueryResult = NonNullable<Awaited<ReturnType<typeof getJudgmentDivisions>>>
export type GetJudgmentDivisionsQueryError = AxiosError<ErrorInfo>

export const useGetJudgmentDivisions = <TData = Awaited<ReturnType<typeof getJudgmentDivisions>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJudgmentDivisions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJudgmentDivisionsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJudgmentDivisions>>> = ({ signal }) => getJudgmentDivisions({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getJudgmentDivisions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * マスタテーブルからマスタ一覧を取得して返す。

 * @summary マスタ管理の一覧取得
 */
export const postMasters = (
    mastersSearchConditions: MastersSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MastersSearch>> => {
    return axios.post(
      `/masters`,
      mastersSearchConditions,options
    );
  }



    export type PostMastersMutationResult = NonNullable<Awaited<ReturnType<typeof postMasters>>>
    export type PostMastersMutationBody = MastersSearchConditions
    export type PostMastersMutationError = AxiosError<ErrorInfo>

    export const usePostMasters = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMasters>>, TError,{data: MastersSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMasters>>, {data: MastersSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postMasters(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postMasters>>, TError, {data: MastersSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * マスタ一覧ダウンロード
 * @summary マスタ一覧ダウンロード
 */
export const postMastersDownload = (
    mastersSearchConditions: MastersSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/masters/download`,
      mastersSearchConditions,options
    );
  }



    export type PostMastersDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postMastersDownload>>>
    export type PostMastersDownloadMutationBody = MastersSearchConditions
    export type PostMastersDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostMastersDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMastersDownload>>, TError,{data: MastersSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMastersDownload>>, {data: MastersSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postMastersDownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postMastersDownload>>, TError, {data: MastersSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * マスタ編集 情報取得
 * @summary マスタ編集 情報取得
 */
export const getMaster = (
    masterVersionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MasterDetail>> => {
    return axios.get(
      `/master/${masterVersionId}`,options
    );
  }


export const getGetMasterQueryKey = (masterVersionId: number,) => [`/master/${masterVersionId}`];

    
export type GetMasterQueryResult = NonNullable<Awaited<ReturnType<typeof getMaster>>>
export type GetMasterQueryError = AxiosError<ErrorInfo>

export const useGetMaster = <TData = Awaited<ReturnType<typeof getMaster>>, TError = AxiosError<ErrorInfo>>(
 masterVersionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMaster>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMasterQueryKey(masterVersionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMaster>>> = ({ signal }) => getMaster(masterVersionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getMaster>>, TError, TData>(queryKey, queryFn, {enabled: !!(masterVersionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * マスタ編集 マスタ更新
 * @summary マスタ編集 マスタ更新
 */
export const postMasterUpdate = (
    masterVersionId: number,
    masterDetail: MasterDetail, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MasterDetail>> => {
    return axios.post(
      `/master/${masterVersionId}/update`,
      masterDetail,options
    );
  }



    export type PostMasterUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postMasterUpdate>>>
    export type PostMasterUpdateMutationBody = MasterDetail
    export type PostMasterUpdateMutationError = AxiosError<ErrorInfo>

    export const usePostMasterUpdate = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMasterUpdate>>, TError,{masterVersionId: number;data: MasterDetail}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMasterUpdate>>, {masterVersionId: number;data: MasterDetail}> = (props) => {
          const {masterVersionId,data} = props ?? {};

          return  postMasterUpdate(masterVersionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postMasterUpdate>>, TError, {masterVersionId: number;data: MasterDetail}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * マスタ編集 ファイルアップロード
 * @summary マスタ編集 ファイルアップロード
 */
export const postMasterMupload = (
    masterVersionId: number,
    postMasterMuploadBody: PostMasterMuploadBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostMasterMupload200>> => {const formData = new FormData();
if(postMasterMuploadBody.file !== undefined) {
 formData.append('file', postMasterMuploadBody.file)
 }

    return axios.post(
      `/master/${masterVersionId}/upload`,
      formData,options
    );
  }



    export type PostMasterMuploadMutationResult = NonNullable<Awaited<ReturnType<typeof postMasterMupload>>>
    export type PostMasterMuploadMutationBody = PostMasterMuploadBody
    export type PostMasterMuploadMutationError = AxiosError<ErrorInfo>

    export const usePostMasterMupload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMasterMupload>>, TError,{masterVersionId: number;data: PostMasterMuploadBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMasterMupload>>, {masterVersionId: number;data: PostMasterMuploadBody}> = (props) => {
          const {masterVersionId,data} = props ?? {};

          return  postMasterMupload(masterVersionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postMasterMupload>>, TError, {masterVersionId: number;data: PostMasterMuploadBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * テンプレート・マスタファイルのダウンロード
 * @summary テンプレート・マスタファイルのダウンロード
 */
export const masterFile = (
    masterVersionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/master/${masterVersionId}/file`,options
    );
  }


export const getMasterFileQueryKey = (masterVersionId: number,) => [`/master/${masterVersionId}/file`];

    
export type MasterFileQueryResult = NonNullable<Awaited<ReturnType<typeof masterFile>>>
export type MasterFileQueryError = AxiosError<ErrorInfo>

export const useMasterFile = <TData = Awaited<ReturnType<typeof masterFile>>, TError = AxiosError<ErrorInfo>>(
 masterVersionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof masterFile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMasterFileQueryKey(masterVersionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof masterFile>>> = ({ signal }) => masterFile(masterVersionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof masterFile>>, TError, TData>(queryKey, queryFn, {enabled: !!(masterVersionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * テンプレートサムネイルデータを取得する(署名付きURLによるアクセスが必要)

 * @summary テンプレートサムネイル取得
 */
export const getMasterThumbnail = (
    masterVersionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/master/${masterVersionId}/thumbnail`,options
    );
  }


export const getGetMasterThumbnailQueryKey = (masterVersionId: number,) => [`/master/${masterVersionId}/thumbnail`];

    
export type GetMasterThumbnailQueryResult = NonNullable<Awaited<ReturnType<typeof getMasterThumbnail>>>
export type GetMasterThumbnailQueryError = AxiosError<ErrorInfo>

export const useGetMasterThumbnail = <TData = Awaited<ReturnType<typeof getMasterThumbnail>>, TError = AxiosError<ErrorInfo>>(
 masterVersionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMasterThumbnail>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMasterThumbnailQueryKey(masterVersionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMasterThumbnail>>> = ({ signal }) => getMasterThumbnail(masterVersionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getMasterThumbnail>>, TError, TData>(queryKey, queryFn, {enabled: !!(masterVersionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

